import { useDroppable } from "@dnd-kit/core";
import { buildSlotId } from "@/lib/agenda-drag";

export type GridLinesMode = "off" | "subtle" | "strong";

type Props = {
  date: Date;
  time: string;
  /** Agenda por sala: a sala da coluna vai no id do slot. */
  sala?: string;
  top: number;
  height: number;
  gridLines: GridLinesMode;
  isHighlighted?: boolean;
};

/** Slot vazio droppable — aceita card arrastado. */
export function DroppableSlot({
  date,
  time,
  sala,
  top,
  height,
  gridLines,
  isHighlighted,
}: Props) {
  const { setNodeRef, isOver } = useDroppable({
    id: buildSlotId(date, time, sala),
    data: { date, time, sala },
  });

  // 3 variantes de grid — "strong" é pra monitores de baixa resolução onde
  // zinc-100 somem. Hora cheia (HH:00) ganha traço extra forte no modo strong.
  const isHourBoundary = time.endsWith(":00");
  const borderClass =
    gridLines === "off"
      ? ""
      : gridLines === "strong"
        ? isHourBoundary
          ? "border-t-[1.5px] border-zinc-300 dark:border-white/20"
          : "border-t border-zinc-200 dark:border-white/10"
        : "border-t border-zinc-100 dark:border-white/[0.04]";

  return (
    <div
      ref={setNodeRef}
      className={`absolute left-0 right-0 transition-colors duration-75 ${borderClass} ${
        isOver ? "bg-brand-200/70 dark:bg-primary/30" : ""
      }`}
      style={{ top, height }}
      data-highlighted={isHighlighted || undefined}
    />
  );
}
